/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */ /*
 * Licensed Materials - Property of IBM
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'VerifyIdentityResult_Title',
    defaultMessage: 'Verify Your Identity - Results',
  },
  successMessage: {
    id: 'VerifyIdentityResult_Success',
    defaultMessage: 'You have successfully completed the verification process.',
  },
  /* BEGIN SD-1029 - MS - text fixes */
  dshErrorResponseMessage_infoOne: {
    id: 'VerifyIdentityResult_DSHErrorResponse_InfoOne',
    defaultMessage:
      'Your account has been successfully created. However, we are unable to verify your identity at this time.',
  },
  /* END SD-1029 - MS - text fixes */
  /* BEGIN SD-1029 - MS - text fixes */
  dshErrorResponseMessage_infoTwo: {
    id: 'VerifyIdentityResult_DSHErrorResponse_InfoTwo',
    defaultMessage:
      'To expedite the processing of your application, you will need to complete the identity verification process. To complete the identity verification process over the phone, call 1-866-578-5409 and give them the following code. Verification ID {dshReferenceNumber}.',
  },
  /* END SD-1029 - MS - text fixes */
  /* BEGIN SD-1029 - MS - text fixes */
  dshErrorResponseMessage_infoThree: {
    id: 'VerifyIdentityResult_DSHErrorResponse_InfoThree',
    defaultMessage:
      'Alternatively, please be aware that you may have to complete the verification process by providing documentation to the Department of Social Services.',
  },
  /* END SD-1029 - MS - text fixes */
  /* BEGIN SD-1029 - MS - text fixes */
  dshErrorResponseMessage_infoFour: {
    id: 'VerifyIdentityResult_DSHErrorResponse_InfoFour',
    defaultMessage: 'Please select one of the checkboxes: ',
  },
  /* END SD-1029 - MS - text fixes */
  /* BEGIN SD-1029 - MS - text fixes */
  experianCallCheckboxMessage: {
    id: 'VerifyIdentityResult_ExperianCallCheckbox',
    defaultMessage:
      'By checking this box, I am confirming that I called the number provided and completed my identity verification over the phone.',
  },
  /* END SD-1029 - MS - text fixes */
  /* BEGIN SD-1029 - MS - text fixes */
  officeVisitCheckboxMessage: {
    id: 'VerifyIdentityResult_OfficeVisitCheckbox',
    defaultMessage:
      'By checking this box, I am confirming that I will complete the verification process by providing documentation to the Department of Social Services.',
  },
  /* END SD-1029 - MS - text fixes */
  twoCheckboxValidationMessage: {
    id: 'VerifyIdentityResult_TwoCheckboxValidationMessage',
    defaultMessage: 'Please check one of the boxes below.',
  },
  oneCheckboxValidationMessage: {
    id: 'VerifyIdentityResult_OneCheckboxValidationMessage',
    defaultMessage: 'Please check the box below.',
  },
  next: {
    id: 'VerifyIdentityResult_Next',
    defaultMessage: 'Next',
  },
});
